import { customSpringAxios } from "./axios";

/**
 * v2 pretraga ume da vrati ISTI polazak više puta — spoj u proceduri množi
 * redove, pa dupli zapisi stignu identični. POS to isto sažima u `applyFilter`
 * (bussoft), samo sa `lineId` u ključu; ovde je izostavljen jer `tripId` već
 * određuje liniju. Prvi red pobeđuje — duplikati su isti, pa izbor ne menja ništa.
 */
export const dedupeTrips = (list) => {
    const seen = new Set();
    return (list || []).filter((trip) => {
        const key = `${trip.tripId ?? trip.id}-${trip.arrivalStationId}-${trip.departureTime}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
};

export const searchTripsApi = async (data) => {
    const { departureStationId, arrivalStationId, from, toLocationId } = data;

    const payload = {
        departureStationId,
        arrivalStationId: toLocationId ? null : arrivalStationId,
        from: from ? new Date(from).toISOString().split('T')[0] : null,
        to: from ? new Date(from).toISOString().split('T')[0] : null,
        toLocationId: toLocationId || null,
        showWithoutRate: false,
    };

    const response = await customSpringAxios.post("/trip/v2/search/online", payload);
    return dedupeTrips(response.data);
};

// Prvi sledeći dan (posle `after`, najviše `horizonDays` unapred) sa kupovinim
// polaskom na relaciji — za prazan rezultat pretrage. Ista v2 pretraga, samo sa
// opsegom datuma; vraća "YYYY-MM-DD" ili null. Preskaču se otkazani i rasprodati
// polasci da se korisniku ne predloži dan na kom ništa ne može da kupi.
export const findNextDepartureDateApi = async ({ departureStationId, arrivalStationId, after, horizonDays = 30 }) => {
    const base = new Date(after);
    if (Number.isNaN(base.getTime())) return null;
    const iso = (d) => d.toISOString().split("T")[0];
    const start = new Date(base);
    start.setDate(start.getDate() + 1);
    const end = new Date(base);
    end.setDate(end.getDate() + horizonDays);

    const response = await customSpringAxios.post("/trip/v2/search/online", {
        departureStationId,
        arrivalStationId,
        from: iso(start),
        to: iso(end),
        toLocationId: null,
        showWithoutRate: false,
    });
    const dates = (response.data || [])
        .filter((trip) => !trip.canceled && (trip.freeSeats == null || trip.freeSeats > 0))
        .map((trip) => String(trip.departureTime || "").slice(0, 10))
        .filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d))
        .sort();
    return dates[0] || null;
};

// DEPRECATED: bez pozivalaca u aplikaciji. Zauzeće se čita kroz allSeatsAPI (/trip/{id}/seats);
// endpoint na serveru je @Deprecated i čeka seču uz telemetriju nula poziva.
// export const occupiedSeatsAPI = async ({ tripId, journeyDate, fromStationId, toStationId }) => {
//     const response = await customSpringAxios.get(
//         `/trip/${tripId}/seats/occupied?journeyDate=${journeyDate}&depId=${fromStationId}&arrId=${toStationId}`
//     );
//     return response.data;
// };

export const allSeatsAPI = async ({ tripId, date, depId, arrId }) => {
    let url = `/trip/${tripId}/seats?date=${date}`;
    if (depId) url += `&depId=${depId}`;
    if (arrId) url += `&arrId=${arrId}`;
    const response = await customSpringAxios.get(url);
    return response.data;
};

export const getTripDetails = async (tripId) => {
    const response = await customSpringAxios.get(`/trip/${tripId}`);
    return response.data;
};

export const getLineStationsByLineId = async (lineId) => {
    const response = await customSpringAxios.get(`/lineStation/line/${lineId}?size=2000&sort=departureTime,asc`);
    return response.data;
};

// Napomene prevoznika za stanice na konkretnom polasku (npr. "polazak sa perona 5"),
// samo one koje je prevoznik označio kao vidljive kupcima.
export const getTripStationNotes = async (tripId) => {
    const response = await customSpringAxios.get(`/trip-station-info/trip/${tripId}/online`);
    return response.data || [];
};
